import { StyleSheet } from 'react-native'
import styled from "styled-components/native"

const styles = StyleSheet.create({
    enviado: {
        background: "red"
    },
    recebido: {
        background: "green"
    }
})

export default styles

export const Container = styled.View`
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    background: #ffffff;
    shadow-opacity: 0.2;
    shadow-radius: 5px;
    shadow-color: #000000;
    shadow-offset: -5px 5px;
    elevation: 8;
    z-index: 3;
`

export const ContatoCard = styled.TouchableOpacity`
    padding: 10px;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
`